export const siteInfo = {
  name: 'Flex Group SARLU',
  tagline: 'FLEX GROUP SARLU est une entreprise spécialisée dans les domaines du génie civil, de la construction et de l’ingénierie.',
  phone: '+243 970 534 664',
  phoneHref: 'tel:+243970534664',
  email: 'contact@flexgroup.africa',
  address: 'Local 9, Bâtiment du PNMLS, Croisement Boulevard Triomphal – Avenue de la Libération, C. de Kasa-Vubu, Kinshasa – R.D. Congo',
  addressManiema: 'N°2, Avenue Tshopo, Q. Lwana, C. Kasuku, Bloc Hewa Bora, Province du Maniema, RDC',
  hours: [
    { day: 'Lun - Ven', time: '9h - 20h' },
    { day: 'Samedi', time: '10h - 16h' },
    { day: 'Dimanche', time: 'Fermé' },
  ],
  legal: 'RCCM : CD/KNM/RCCM/21-B-00554 | ID National : 01-F4200-N89606Y',
  socials: {
    facebook: 'https://www.facebook.com/flexgroup2021',
    x: 'https://x.com/FlexGroupSarlu',
    instagram: 'https://www.instagram.com/flex_group2021/',
    linkedin: 'https://www.linkedin.com/in/flex-group-ir-dodo-baruka-87aaa9344/',
  },
};

export const mainLinks = [
  { label: 'Réalisations', to: '/portfolio' },
  { label: 'À propos', to: '/about' },
  { label: 'Galerie', to: '/galerie' },
  { label: 'Actualités', to: '/blog' },
];
